import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";
import { ApiBaseUrls, ApiControllers } from "../../constants/constants";
import { ServiceResultModel } from "../../models/service/service-result.model";
import { ServiceUtilities } from "../../utilities/service.utilities";
import { APISanitizerUtilities } from "../../utilities/api-sanitizer.utilities";
import { BulkActionResponse } from "../../models/service/bulk-action-response.model";
import { SendBulkEmailRequest } from "../../models/data/send-bulk-email.model";

@Injectable({
  providedIn: 'root'
})
export class CommunicationsService {
  // The send endpoint lives on the CORE API (not the messaging API like the sent-email browser) — it
  // resolves recipients, renders the template, and enqueues the messages on the Service Bus.
  private apiPath: string = `${ApiBaseUrls.CORE()}${ApiControllers.MESSAGES()}`;

  constructor(private httpClient: HttpClient) { }

  public async sendBulkEmail(request: SendBulkEmailRequest): Promise<ServiceResultModel<BulkActionResponse>> {
    try {
      const requestUrl = `${this.apiPath}/send`;

      const response = await firstValueFrom(
        this.httpClient.post<BulkActionResponse>(
          requestUrl,
          JSON.stringify(APISanitizerUtilities.sanitizePayload<SendBulkEmailRequest>(request)),
          { observe: "response", headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
        ));

      const bulkActionResponse = <BulkActionResponse>response.body?.valueOf();

      return <ServiceResultModel>{ data: bulkActionResponse, success: true, statusCode: response.status };
    } catch (error: any) {
      return ServiceUtilities.handleServiceException(error);
    }
  }
}
